// Shared PDI dropdown option lists so the merchant intake (IntakeForm) and
// the operator admin form (NewApplication) render identical choices.
//
// Gas pump makes per the 2026-07-13 meeting (issue #66); Greg: "it'll
// literally be the Gilbarco, Wayne, or Bennett." Both forms keep an
// "Other" free-text escape hatch, and a stored value outside these three
// hydrates into Other mode automatically.

export const GAS_PUMP_TYPES: readonly string[] = [
  "Gilbarco",
  "Wayne",
  "Bennett",
];
